//@flow
import type { ReducerState$Type,EditForm$Type } from '../genericFlowTypes'

export const transformDataToEditFormData=(data:any,nemesis: ReducerState$Type)=>{
    let formData: EditForm$Type = {}
    
    const nemesisResultset = data['nemesisResultset']
    formData.isInvalidDoc = nemesisResultset['is_invalid_doc']?nemesisResultset['is_invalid_doc']:false
    formData.isOverrideCustomerName = nemesisResultset['is_override_customer_name']?nemesisResultset['is_override_customer_name']:false
    formData.isOverrideTotal = nemesisResultset['is_override_total']?nemesisResultset['is_override_total']:false
    
    if (nemesisResultset['po_no']){
        formData.poNo = nemesisResultset['po_no']
    }
    if (nemesisResultset['po_date']){
        formData.poDate = nemesisResultset['po_date']
    }
    if (nemesisResultset['service_addr']){
        formData.serviceAddr = nemesisResultset['service_addr']
    }
    if (nemesisResultset['total']){
        formData.total = parseFloat(nemesisResultset['total'])
    }
    if (nemesisResultset['customer_name']){
        formData.customerName = nemesisResultset['customer_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/nemesis/editFormData.js